// eslint-disable-next-line import/no-anonymous-default-export
export default {
  title: 'Servers',
  subtitle: 'Manage all hosting servers',
  server: 'Server',
  newServer: 'New Server',
  addServer: 'Add Server',
  editServer: 'Edit Server',
  updateServer: 'Update Server',
  serverList: 'Server List',
  serverName: 'Server Name',
  ipAddress: 'IP Address',
  hostname: 'Hostname',
  provider: 'Provider',
  plan: 'Plan',
  cost: 'Cost',
  paymentFrequency: 'Payment Frequency',
  expiryDate: 'Expiry Date',
  status: 'Status',
  uptime: 'Uptime',
  lastCheck: 'Last check',
  noServers: 'No servers yet',
  noServersDesc: 'Start by adding your first server.',
  serverAdded: 'Server successfully added',
  serverUpdated: 'Server successfully updated',
  serverDeleted: 'Server successfully deleted',
  fetchError: 'Servers could not be retrieved',
  addError: 'Server could not be added',
  updateError: 'Server could not be updated',
  deleteError: 'Server could not be deleted',
  confirmDelete: 'Are you sure you want to delete this server?',
  uptimeToggleError: 'Uptime monitoring cannot be enabled without IP address or hostname',
  uptimeEnabled: 'Uptime monitoring enabled',
  uptimeDisabled: 'Uptime monitoring disabled',
  uptimeToggleError2: 'Uptime status could not be updated',
  ipOrHostnameRequired: 'IP address or hostname is required',
  uptimeActive: 'Uptime monitoring active',
  uptimePassive: 'Uptime monitoring passive'
};
